import React, { useState } from 'react';
import { FilterIcon, ClockIcon, MessageSquareIcon, UserIcon } from 'lucide-react';
import { userTickets } from '../data/mockData';
import { StatusBadge } from './StatusBadge';
import { TicketDetailModal } from './TicketDetailModal';
interface MyTicketsProps {
  onNavigate: (view: string) => void;
}
export function MyTickets({
  onNavigate
}: MyTicketsProps) {
  const [statusFilter, setStatusFilter] = useState('All');
  const [selectedTicket, setSelectedTicket] = useState<any | null>(null);
  const filters = ['All', 'New', 'In Progress', 'Waiting on User', 'Resolved'];
  const filteredTickets = userTickets.filter(ticket => statusFilter === 'All' ? true : ticket.status === statusFilter);
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-96">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-8 gap-4" data-id="element-97">
        <div data-id="element-98">
          <h1 className="text-3xl font-bold text-slate-900 mb-2" data-id="element-99">My Tickets</h1>
          <p className="text-slate-600" data-id="element-100">
            Track the status of your support requests.
          </p>
        </div>

        <button onClick={() => onNavigate('submit-ticket')} className="hidden sm:flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-xl hover:bg-blue-700 transition-colors" data-id="element-101">
          Submit New Ticket
        </button>
      </div>

      {/* Filters */}
      <div className="bg-white p-4 rounded-2xl border border-slate-200 shadow-sm mb-6 flex items-center overflow-x-auto" data-id="element-102">
        <FilterIcon className="w-5 h-5 text-slate-400 mr-4 flex-shrink-0" data-id="element-103" />
        <div className="flex space-x-2 min-w-max" data-id="element-104">
          {filters.map(filter => <button key={filter} onClick={() => setStatusFilter(filter)} className={`px-4 py-1.5 rounded-lg text-sm font-medium transition-colors ${statusFilter === filter ? 'bg-slate-100 text-slate-900 border border-slate-300' : 'text-slate-600 hover:bg-slate-50 border border-transparent'}`} data-id="element-105">
              {filter}
            </button>)}
        </div>
      </div>

      {/* Ticket List */}
      <div className="space-y-4" data-id="element-106">
        {filteredTickets.length > 0 ? filteredTickets.map(ticket => <div key={ticket.id} onClick={() => setSelectedTicket(ticket)} className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden hover:shadow-md hover:border-blue-300 transition-all cursor-pointer group" data-id="element-107">
              <div className="p-6" data-id="element-108">
                <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 mb-4" data-id="element-109">
                  <div data-id="element-110">
                    <div className="flex items-center space-x-3 mb-2" data-id="element-111">
                      <span className="font-mono text-sm font-bold text-slate-500" data-id="element-112">
                        {ticket.id}
                      </span>
                      <StatusBadge type="status" value={ticket.status} data-id="element-113" />
                      <StatusBadge type="priority" value={ticket.priority} data-id="element-114" />
                    </div>
                    <h3 className="text-lg font-bold text-slate-900 group-hover:text-blue-600 transition-colors" data-id="element-115">
                      {ticket.subject}
                    </h3>
                  </div>
                  <div className="text-right text-sm text-slate-500 flex flex-col items-start md:items-end" data-id="element-116">
                    <span className="flex items-center mb-1" data-id="element-117">
                      <ClockIcon className="w-4 h-4 mr-1.5" data-id="element-118" /> Submitted{' '}
                      {ticket.submittedDate}
                    </span>
                    <span className="flex items-center" data-id="element-119">
                      <UserIcon className="w-4 h-4 mr-1.5" data-id="element-120" />{' '}
                      {ticket.assignedTo ? `Assigned to ${ticket.assignedTo}` : 'Unassigned'}
                    </span>
                  </div>
                </div>

                <p className="text-slate-600 text-sm mb-6 line-clamp-2" data-id="element-121">
                  {ticket.description}
                </p>

                <div className="flex flex-col sm:flex-row sm:items-center justify-between pt-4 border-t border-slate-100 gap-4" data-id="element-122">
                  <div className="flex items-center text-sm text-slate-500" data-id="element-123">
                    <MessageSquareIcon className="w-4 h-4 mr-2 text-blue-500" data-id="element-124" />
                    <span className="font-medium text-slate-700 mr-2" data-id="element-125">
                      Latest update:
                    </span>
                    {ticket.lastUpdate}
                  </div>

                  {/* Progress Bar */}
                  <div className="w-full sm:w-48 flex items-center space-x-3" data-id="element-126">
                    <div className="flex-1 h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-127">
                      <div className={`h-full rounded-full ${ticket.status === 'Resolved' ? 'bg-green-500' : ticket.status === 'New' ? 'bg-blue-500' : 'bg-amber-500'}`} style={{
                  width: `${ticket.progress}%`
                }} data-id="element-128"></div>
                    </div>
                    <span className="text-xs font-medium text-slate-500 w-8 text-right" data-id="element-129">
                      {ticket.progress}%
                    </span>
                  </div>
                </div>
              </div>
            </div>) : <div className="text-center py-20 bg-white rounded-2xl border border-slate-200 border-dashed" data-id="element-130">
            <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-131">
              <FilterIcon className="w-8 h-8 text-slate-400" data-id="element-132" />
            </div>
            <h3 className="text-lg font-medium text-slate-900 mb-2" data-id="element-133">
              No tickets found
            </h3>
            <p className="text-slate-500" data-id="element-134">
              You don't have any tickets matching the "{statusFilter}" status.
            </p>
          </div>}
      </div>

      {/* Ticket Detail Modal */}
      {selectedTicket && <TicketDetailModal ticket={selectedTicket} onClose={() => setSelectedTicket(null)} data-id="element-135" />}
    </div>;
}